import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { I18nextProvider } from "react-i18next";
import i18next from "./i18n/config";

import App from "./App.tsx";
import "./index.css";
import AuthContextProvider from "./context/AuthContext.tsx";
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";

const VITE_ENV = import.meta.env.VITE_ENV;

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_COGNITO_POOL_ID,
            userPoolClientId: import.meta.env.VITE_COGNITO_POOL_CLIENT_ID
        }
    }
});
// cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);
if (VITE_ENV === "production") cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({ domain: "drake-ltim.com" }));
else cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <I18nextProvider i18n={i18next}>
            <AuthContextProvider>
                <App />
            </AuthContextProvider>
        </I18nextProvider>
    </StrictMode>
);
